export const AMPLITUDE_EVENTS = {
    loginScreenOpening: 'log_in_screen_opening',
    btnSignIn: 'button_sign_in',
    secondFactorScreenOpening: '2fa_screen_opening',
    smsResend: 'sms_resend',
    signInSuccessSite: 'sign_in_success_site',
    mainPageOpening: 'main_page_opening',
    signUpScreenOpening: 'sign_up_screen_opening',
    signUpIndividualScreenOpening: 'sign_up_individual_screen_opening',
    emailVerificationScreenOpening: 'email_verification_screen_opening',
    emailVerificationSuccess: 'email_verification_success',
    phoneNumberScreenOpening: 'phone_number_screen_opening',
    smsRequestClick: 'sms_request_click',
    phoneNumberVerificationScreenOpening: 'phone_number_verification_screen_opening',
    phoneNumberVerificationSuccess: 'phone_number_verification_success',
    signUpSuccessSite: 'sign_up_success_site',
    signUpBusinessScreenOpening: 'sign_up_business_screen_opening',
    kybScreenOpening: 'kyb_screen_opening',
    kybQuestionnaireDownloaded: 'kyb_questionnaire_downloaded',
    kybQuestionnaireSent: 'kyb_questionnaire_sent',
    redirectFinishRegistration: 'redirect_finish_registration',
    forgotPasswordClick: 'forgot_password_click',
    requestPasswordUpdate: 'request_password_update',
    passwordUpdateSuccess: 'password_update_success',
    kybVerificationScreenOpening: 'kyb_verification_screen_opening',
    kybVerificationRedirectSumsub: 'kyb_verification_redirect_sumsub',
    kybVerificationPendingScreenOpening: 'kyb_verification_pending_screen_opening',
    emailCodeSent: 'email_code_sent',
}

export const AMPLITUDE_BUSINESS_ROUTES = [
    '/sign-up/business/',
]
